import { DropdownItemProps } from '@cas/components/inputs/dropdown-items/DropdownItems';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

// Maps to a translation.
export enum OnOff {
  On = 'On',
  Off = 'Off',
}

// Maps to a translation.
export enum EntryExit {
  Entry = 'Entry',
  Exit = 'Exit',
}

// Keep this list manually configured to maintain control over the properties associated with each ID.
// [ID(1-12), input(2/3/4), ON/OFF, entry/exit]
const inputOptions: [number, number, OnOff, EntryExit][] = [
  [1, 2, OnOff.On, EntryExit.Entry],
  [2, 2, OnOff.On, EntryExit.Exit],
  [3, 2, OnOff.Off, EntryExit.Entry],
  [4, 2, OnOff.Off, EntryExit.Exit],
  [5, 3, OnOff.On, EntryExit.Entry],
  [6, 3, OnOff.On, EntryExit.Exit],
  [7, 3, OnOff.Off, EntryExit.Entry],
  [8, 3, OnOff.Off, EntryExit.Exit],
  [9, 4, OnOff.On, EntryExit.Entry],
  [10, 4, OnOff.On, EntryExit.Exit],
  [11, 4, OnOff.Off, EntryExit.Entry],
  [12, 4, OnOff.Off, EntryExit.Exit],
];

export const useInputOptions = (): DropdownItemProps<number>[] => {
  const { t } = useTranslation();

  return useMemo(() => {
    return inputOptions.map(([id, input, onOrOff, entryOrExit]) => ({
      key: id.toString(),
      value: id,
      stringValue: id.toString(),
      label: t('InputOption', { input, onOrOff, entryOrExit }),
    }));
  }, [t]);
};

export default useInputOptions;
